<template>
	<div ref="ocrHistory" class="dialog-container">
		<div class="dialog" style="max-height: 560px; transform: translate(0, -280px); max-width: 1500px;">
			<form @submit.stop="doValidation()">
				<div class="top" style="height: 30px">
					<p class="txt-crud-title">
						Ocr History
					</p>
				</div>
				<div class="center">
					<table class="tb-list-vertical">
                        <colgroup>
                            <col width="5%" />
                            <col width="17%" />
                            <col width="10%" />
                            <col width="8%" />
                            <col width="auto" />
                            <col width="8%" />
                            <col width="8%" />
                            <col width="8%" />
                            <col width="20%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>
                                    No
                                </th>
                                <th>
                                    Screening No
                                </th>
                                <th>
                                    Visit
                                </th>
                                <th>
                                    Page
                                </th>
                                <th>
                                    Ocr Template
                                </th>
                                <th>
                                    Parsed Data
                                </th>
                                <th>
                                    Result Data
                                </th>
                                <th>
                                    User
                                </th>
                                <th>
                                    Date/Time
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(history, index) in ocrHistoryList" :key="index">
                                <td>
                                    {{ index+1 }}
                                </td>
                                <td>
                                    {{ history.screeningName }}
                                </td>
                                <td>
                                    {{ history.visitName }}
                                </td>
                                <td>
                                    {{ history.pageName }}
                                </td>
                                <td>
                                    {{ history.ocrName }}
                                </td>
                                <td>
                                    {{ history.parsedData }}
                                </td>
                                <td>
                                    {{ history.resultData }}
                                </td>
                                <td>
                                    <b>{{ history.userId }}</b>
                                    ({{ history.userName }})<br>
                                </td>
                                <td>
                                    {{ history.ocrDate.substring(0, 19) }}
                                </td>
                            </tr>
                            <tr v-if="ocrHistoryList.length == 0">
                                <td colspan="10" class="no-list">
                                    There is no registered page, Please register the page.
                                </td>
                            </tr>
                        </tbody>
                    </table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doClose()">
						Close
					</button>
                    <button type="button" class="btn-cancel fright" title="Cancel" @click="excelDownload()">
						Excel Download
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
    name: "OcrHistory",
	created() {
        this.logger.debug(this, "created()");
        this.item.screeningNo = this.param.screeningNo;
        this.item.testScreeningNo = this.param.testScreeningNo;
        this.item.visitNo = this.param.visitNo;
        this.item.pageNo = this.param.pageNo;
        
        this.selectScreeningOcrHistory();
    },
    props: {
        param: {
            type: Object,
            required: true
        }
    },
	data() {
		return {
            item: {},
            ocrHistoryList: [],
		};
    },
	methods: {
		selectScreeningOcrHistory() {
            this.logger.debug(this, "selectScreeningOcrHistory()");
            
			axios
				.post(this.config.contextRoot + "/ocr/screening/selectScreeningOcrHistory.do", this.item)
				.then((response) => {
					console.log(response);
                    this.ocrHistoryList = response.data.ocrHistoryList;
                    this.ocrHistoryList.forEach((history) => {
                        history.userId = history.firstRegistUserId;
                        history.ocrDate = history.firstRegistDate;
                    });
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
        },
        excelDownload() {
            EventBus.$emit("project-loading", true);
            this.logger.debug(this, "excelDownload()");
            
            this.item.ocrHistoryVoList = this.ocrHistoryList;
            
			axios
				.post(this.config.contextRoot + "/excel/ocrHistoryDownload.do", this.item, {responseType: "blob"})
				.then((response) => {
					console.log(response);
                    const url = window.URL.createObjectURL(
						new Blob([response.data], {type: response.headers["content-type"]})
					);
					const link = document.createElement("a");
					link.href = url;
					
					let today = new Date();
					let year = today.getFullYear();
					let month = ('0' + (today.getMonth() +1)).slice(-2);
					let day = ('0' + (today.getDate())).slice(-2);
                    
					today = year + "-" + month + "-" + day;
                    
                    var name = "Ocr_History_" + this.param.screeningName + "_" + this.param.visitName + "_" + this.param.pageName;
                    
					link.setAttribute("download", name + "_"+today+".xlsx");
					document.body.appendChild(link);
					link.click();
                    
					EventBus.$emit("project-loading", false);
					
					this.$alert("The file has been downloaded.", "Info", "info").then((result) => {
						if (result === true) {
							// location.reload();
						}
					});
				})
				.catch((error) => {
                    this.exceptionHandler(this, error);
				});
                
        },
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.ocrHistory.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.ocrHistory.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("history-close", "isOcrHistory");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
</style>